import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'styles/UploadImageButton.css';
import SignInPopup from 'components/login/SignInPopup';
import {usePopup} from 'popup/PopupContext';

const UploadImageButton = () => {
    const navigate = useNavigate();
    const user = localStorage.getItem('isLoggedIn');
    const {openPopup} = usePopup();
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        if (user) {
            navigate('/upload');
        } else {
            openPopup(<SignInPopup/>, () => {
            }, true);
        }
    };

    return (
        <div className="upload-image-icon" onClick={handleClick}>
            <svg
                width="362"
                height="51"
                viewBox="0 0 362 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M361.653 51H0.0936242C0.031444 50.8119 0 50.6227 0 50.4322C59.4572 50.4322 94.9419 37.9403 130.637 25.3745C164.615 13.413 198.783 1.3845 254 0C306.789 1.09541 354.134 34.8524 361.653 51Z"
                    fill="#266F2D"
                    className="upload-image-path"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                />
            </svg>
            <div
                className={`plus-overlay ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >

                <div className="circle">
                    <button className="plus-button">+</button>
                </div>
            </div>
        </div>
    );
};

export default UploadImageButton;
